<template>
  <div class="getParams-wrapper">
    <el-form
      ref="formDate"
      :model="formDate"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
      label-position="left"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="公司组织ID" prop="orgid">
            <el-select
              v-model="formDate.orgid"
              placeholder="请选择"
              clearable
              disabled
              class="auto-width"
            >
              <el-option
                v-for="item in orgOtion"
                :key="item.OrgId"
                :label="item.OrgName"
                :value="item.OrgId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="系统根路径" prop="path">
            <el-input v-model="formDate.path" placeholder="请输入系统根路径"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="formDate.params" label="params" prop="params">
            <el-input v-model="formDate.params" type="textarea" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-button type="primary" @click="handleGetParams()">确定</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'Index',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      formDate: {
        orgid: '',
        params: '',
        chain_id: this.$route.query.chainId,
        user_id: String(JSON.parse(localStorage.getItem('cbaas_system_userInfo')).ID),
        path: ''
      },
      editRules: {
        path: [{ required: true, message: '请输入系统根路径', trigger: 'blur' }],
        orgid: [{ required: true, message: '请选择公司组织ID', trigger: 'blur' }]
      },
      orgOtion: [],
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  mounted() {
    this.formDate.path = localStorage.getItem('path')
    this.formDate.orgid = localStorage.getItem('orgid')
    this.getOptions()
  },
  methods: {
    getOptions() {
      this.$apis.chain
        .getChainOrgList({ limit: 1000, offset: 0, chainId: this.$route.query.chainId })
        .then(res => {
          if (res.data && res.data.items) {
            let hasObj = {}
            this.orgOtion = res.data.items.reduce((result, cur) => {
              if (!hasObj[cur.OrgId]) {
                hasObj[cur.OrgId] = true
                result.push(cur)
              }
              return result
            }, [])
          }
        })
    },
    handleGetParams() {
      this.$refs.formDate.validate(valid => {
        if (valid) {
          this.$apis.hibe.getParams(this.formDate).then(res => {
            if (res) {
              this.formDate.params = res.data.params
              this.$message.success('获取params成功!')
            }
          })
        }
      })
    },

    changeText() {
      this.isChangeText = !this.isChangeText
      this.isChangeText
        ? (this.proclaimedTextEncryption = this.proclaimedText)
        : (this.proclaimedTextEncryption = '********')
    },
    methodChange(val) {
      localStorage.setItem('method', val)
    }
  }
}
</script>

<style scoped lang="scss">
.getParams-wrapper {

  .el-row {
    margin: 0 calc(0px - var(--base-size-16));
    
    .el-col {
      padding: 0 var(--base-size-16);
    }
  }
  
}
</style>
